<template>
    <div>
        <h1>{{ $t("admin.adminNotificationView.header") }}</h1>
        <form id="search" @submit="updateNotification">
            <label for="subject">{{ $t("admin.adminNotificationView.subject") }}: </label><input id="subject" name="subject" v-model="notificationData.subject"><br/>
            <label for="description">{{ $t("admin.adminNotificationView.description") }}: </label><textarea id="description" name="description" v-model="notificationData.description"></textarea><br/>
            <label>{{ $t("admin.adminNotificationView.date") }}: </label><date-picker v-model="notificationData.date" format="YYYY/MM/DD" value-type="format" type="date" v-bind:placeholder="$t('admin.adminNotificationView.placeholder')"></date-picker><br/>
            <label for="enabled">{{ $t("admin.adminNotificationView.enabled") }}: </label><input id="enabled" name="enabled" v-model="notificationData.enabled" type="checkbox"><br/>

            <input type="submit" class="submit" v-bind:value="$t('admin.adminNotificationView.button.update')">
        </form>
        <AdminNotificationDelete v-bind:notification="notificationData" />
        <hr>
        <h2>{{ $t("admin.adminNotificationView.review") }}</h2>
        <h3>{{ this.notificationData.date }}</h3>
        <h2>{{ this.notificationData.subject }}</h2>
        <p v-html="this.notificationData.description"></p>
    </div>
</template>

<script>
    import { adminService } from '@/services/admin.service'
    import AdminNotificationDelete from "./AdminNotificationDelete";
    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/locale/ja';

    export default {
        name: 'AdminNotificationView',
        components: {
            AdminNotificationDelete,
            DatePicker
        },
        data: function() {
            return {
                notificationData: {}
            };
        },
        created: function() {
            this.fetchData();
        },
        methods: {
            fetchData: function () {
                adminService.notificationGet(this.$route.params.notificationId).then((data) => {
                    let tmpNotificationData = data
                    tmpNotificationData.description = decodeURIComponent(atob(data.description))
                    this.notificationData = tmpNotificationData
                }).catch((err) => {
                    console.error('Unable to get notification: ', err)
                })
            },
            updateNotification: function(e) {
                e.preventDefault();
                let tmpNotificationData = JSON.parse(JSON.stringify(this.notificationData));
                tmpNotificationData.description = btoa(encodeURIComponent(this.notificationData.description))
                adminService.notificationUpdate(this.$route.params.notificationId, tmpNotificationData).then(() => {
                    this.fetchData();
                }).catch((err) => {
                    console.error('Unable to update notification: ', err)
                })
            }
        }
    }
</script>
